import { message } from "antd";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getCategories } from "../../../controller/services/common";
import i18n from "../../../localization/i18n";
import {
  setLoading,
  setMenuTitle,
  setShowMenu,
  setShowSubMenu,
} from "../../../redux/slices/common_slice";
import { convertCurrency, formatNumber } from "../../../utils/helper";
import SourceDetailsCard from "../right-sde-wrapper/SourceDetailsCard";

const IncomeDetailsCardInner = ({ all }) => {
  const selectedMonth = useSelector((state) => state.dashboard.selectedMonth);
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  const selectedCurrency = useSelector(
    (state) => state.currency.currencySelected
  );
  const exchangeRates = useSelector((state) => state.currency.exchangeRates);
  const [incomeCategories, setIncomeCategories] = useState([]);
  const params = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fields = [
    {
      name: "income",
      title: t("dashboard.incomeFields.1.title"),
      incomeType: t("dashboard.incomeFields.1.child"),
    },
    {
      name: "additionalIncome",
      title: t("dashboard.incomeFields.2.title"),
      type: "array",
    },
  ];

  useEffect(() => {
    getCategoriesList();
  }, []);
  const getCategoriesList = () => {
    dispatch(setLoading(true));
    getCategories("income")
      .then((resp) => {
        setIncomeCategories(resp.data.category);
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
  const isCurrent = selectedMonth === format(new Date(), "MM-yyyy");
  return (
    <>
      <div className="col-12">
        <div className="row mx-0 all-source-heading">
          <h5 className="mb-0 w-auto">{t("dashboard.incomeSources")}</h5>
          {!params?.id && isCurrent && (
            <Link
              to={"/settings/edit-form/income"}
              onClick={() => {
                dispatch(setShowSubMenu(false));
                dispatch(setShowMenu(false));
                dispatch(setMenuTitle(t("commonStepper.section2")));
              }}
            >
              {t("dashboard.addNewIncome")}
            </Link>
          )}
        </div>
        <div
          className={`row source-main-wrapper ${all === "all" ? "" : "mx-0"}`}
        >
          {dashboardData?.totalIncome != 0 && (
            <div className="col-12">
              {/* pass amt from dashboardData.income */}
              {fields.map((item) => {
                if (
                  item.type === "array" &&
                  dashboardData?.income?.[item?.name]?.length > 0 &&
                  dashboardData?.income?.[item?.name]?.some((i) => i.amount)
                ) {
                  return (
                    <div className={`row source-details-card theme`}>
                      <div className="col-12">
                        <h6 className="mb-0 d-flex align-items-center">
                          {item?.title} <span>{t("monthlyTag")}</span>
                        </h6>
                        {dashboardData?.income?.[item?.name]?.map(
                          (addiIncome) => {
                            const foundType = incomeCategories.find((i) => {
                              return (
                                i.title?.en?.toLowerCase() ==
                                addiIncome?.type?.toLowerCase()
                              );
                            });
                            if (addiIncome?.amount) {
                              return (
                                <div className="sources-name-div">
                                  <h5 className="mb-0">
                                    {foundType
                                      ? foundType?.title?.[i18n.language]
                                      : addiIncome?.type}
                                  </h5>
                                  <h5 className="mb-0">
                                    <small>{selectedCurrency}</small>{" "}
                                    {formatNumber(
                                      convertCurrency(
                                        addiIncome?.amount || 0,
                                        exchangeRates,
                                        selectedCurrency
                                      )
                                    )}
                                  </h5>
                                </div>
                              );
                            }
                          }
                        )}
                      </div>
                    </div>
                  );
                }
                if (
                  dashboardData?.income?.monthlyIncome &&
                  item.type != "array"
                ) {
                  return (
                    <SourceDetailsCard
                      amt={dashboardData?.income?.monthlyIncome}
                      title={item?.title}
                      incomeType={item?.incomeType}
                      isIncome
                    />
                  );
                }
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default IncomeDetailsCardInner;
